// extracted by mini-css-extract-plugin
module.exports = {"donation_head":"DonationList_donation_head__2TBHz","donation_body":"DonationList_donation_body__154D0","donation_title":"DonationList_donation_title__3zbf-"};